// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__ANNxV","signatureButtonsRight":"ModalSign_signatureButtonsRight__2LVxp"};